import { Loader2, Swords } from "lucide-react";
import { motion } from "framer-motion";

export function AuthLoading() {
  return (
    <div className="min-h-screen themed-gradient flex flex-col items-center justify-center">
      <div className="relative">
        <motion.div
          animate={{
            scale: [1, 1.1, 1],
            opacity: [0.5, 1, 0.5],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="relative w-16 h-16"
        >
          <Loader2 className="h-16 w-16 animate-spin text-primary/40" />
          <Swords className="h-8 w-8 text-primary absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
        </motion.div>
      </div>
      <motion.p 
        className="mt-4 text-white/60"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
      >
        Loading...
      </motion.p>
    </div>
  );
}